<template>
  <div>
    <div class="form-wrap">
      <div class="form-list px-2 py-2">
        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.sex_code.$error}">
          <label class="col-2 col-form-label"><trans-text i18nKey="ui[94][3]"/></label>
          <div class="col-10">
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="sex_code" value="1" v-model="input.sex_code" @change="$v.input.sex_code.$touch()"> <trans-text i18nKey="ui[94][4]"/>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="sex_code" value="2"  v-model="input.sex_code" @change="$v.input.sex_code.$touch()"> <trans-text i18nKey="ui[94][5]"/>
              </label>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.sex_code" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][1]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.generation_code.$error}">
          <label class="col-2 col-form-label"><trans-text i18nKey="ui[94][6]"/></label>
          <div class="col-10">
            <form class="form-inline">
              <select class="custom-select mb-2" v-model="input.generation_code" @change="$v.input.generation_code.$touch()">
                <option value="1"><trans-text i18nKey="ui[94][7]"/></option>
                <option value="2"><trans-text i18nKey="ui[94][8]"/></option>
                <option value="3"><trans-text i18nKey="ui[94][9]"/></option>
                <option value="4"><trans-text i18nKey="ui[94][10]"/></option>
                <option value="5"><trans-text i18nKey="ui[94][11]"/></option>
              </select>
            </form>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.generation_code" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][2]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q1_answer.$error}">
          <label class="col-2 col-form-label">Q1.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][12]"/></div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q1"  value="1" v-model="input.q1_answer" @change="$v.input.q1_answer.$touch()"> <trans-text i18nKey="ui[94][13]"/>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q1" value="2" v-model="input.q1_answer" @change="$v.input.q1_answer.$touch()"> <trans-text i18nKey="ui[94][14]"/>
              </label>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q1_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][3]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q2_answer.$error}">
          <label class="col-2 col-form-label">Q2.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][15]"/></div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q2" value="1" v-model="input.q2_answer" @change="$v.input.q2_answer.$touch()"> <trans-text i18nKey="ui[94][16]"/>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q2" value="2" v-model="input.q2_answer" @change="$v.input.q2_answer.$touch()"> <trans-text i18nKey="ui[94][17]"/>
              </label>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q2_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][4]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q3_answer_group.$error}">
          <label class="col-2 col-form-label">Q3.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][18]"/></div>
            <div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="q3" value="1" v-model="input.q3_answer"  @change="$v.input.q3_answer.$touch()"> <trans-text i18nKey="ui[94][19]"/>
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="q3" value="2" v-model="input.q3_answer"  @change="$v.input.q3_answer.$touch()"> <trans-text i18nKey="ui[94][20]"/>
                </label>
              </div>
            </div>
            <div>
              <div class="form-check form-check-inline">
                <form class="form-inline">
                  <label class="form-check-label"><input class="form-check-input" type="radio" name="q3" value="3" v-model="input.q3_answer"> <trans-text i18nKey="ui[94][21]"/></label>
                  <input type="text" class="form-control ml-2 mb-2 mr-sm-2 mb-sm-0" v-model="input.q3_answer_free_text">
                </form>
              </div>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q3_answer_group" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][5]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q4_answer.$error}">
          <label class="col-2 col-form-label">Q4.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][22]"/></div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q4" value="1" v-model="input.q4_answer" @change="$v.input.q4_answer.$touch()"> <trans-text i18nKey="ui[94][23]"/>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q4" value="2" v-model="input.q4_answer" @change="$v.input.q4_answer.$touch()"> <trans-text i18nKey="ui[94][24]"/>
              </label>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q4_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][6]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q5_answer.$error}">
          <label class="col-2 col-form-label">Q5.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][25]"/></div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q5" value="1" v-model="input.q5_answer" @change="$v.input.q5_answer.$touch()"> <trans-text i18nKey="ui[94][26]"/>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q5" value="2" v-model="input.q5_answer" @change="$v.input.q5_answer.$touch()"> <trans-text i18nKey="ui[94][27]"/>
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" name="q5" value="3" v-model="input.q5_answer"> <trans-text i18nKey="ui[94][28]"/>
              </label>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q5_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][7]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q6_answer_group.$error}">
          <label class="col-2 col-form-label">Q6.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][29]"/></div>

            <form class="form-inline">
              <select class="custom-select mb-2" v-model="input.q6_answer" @change="$v.input.q6_answer.$touch()">
                <option value="1"><trans-text i18nKey="ui[94][30]"/></option>
                <option value="2"><trans-text i18nKey="ui[94][31]"/></option>
                <option value="3"><trans-text i18nKey="ui[94][32]"/></option>
                <option value="4"><trans-text i18nKey="ui[94][33]"/></option>
                <option value="5"><trans-text i18nKey="ui[94][34]"/></option>
              </select>
            </form>
            <div><trans-text i18nKey="ui[94][35]"/></div>
            <div class="mb-2">
              <form class="form-inline">
                <input type="text" class="form-control" v-model="input.q6_answer_free_text">
              </form>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q6_answer_group" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][8]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-2 col-form-label">Q7.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][36]"/></div>

            <div class="row mb-2">
              <div class="col-6">
                <div><label class="form-check-label"><input class="form-check-input" type="checkbox" value="1" v-model="input.q7_answer"> <trans-text i18nKey="ui[94][37]"/></label></div>
                <div class="w-50"><img class="img-fluid" src="~assets/demo_anc_q7_1.jpg"></div>
              </div>
              <div class="col-6">
                <div><label class="form-check-label"><input class="form-check-input" type="checkbox" value="2" v-model="input.q7_answer"> <trans-text i18nKey="ui[94][38]"/></label></div>
                <div class="w-50"><img class="img-fluid" src="~assets/demo_anc_q7_2.jpg"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div><label class="form-check-label"><input class="form-check-input" type="checkbox" value="3" v-model="input.q7_answer"> <trans-text i18nKey="ui[94][39]"/></label></div>
                <div class="w-50"><img class="img-fluid" src="~assets/demo_anc_q7_3.jpg"></div>
              </div>
            </div>
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q8_answer_group.$error}">
          <label class="col-2 col-form-label">Q8.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][40]"/></div>

            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="1" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][41]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="2" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][42]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="3" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][43]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="4" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][44]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="5" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][45]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="6" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][46]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="7" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][47]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="8" v-model="input.q8_answer">
                <trans-text i18nKey="ui[94][48]"/>
              </label>
            </div>
            <div class="mb-2">
              <form class="form-inline">
                <input type="text" class="form-control" v-model="input.q8_answer_free_text">
              </form>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q8_answer_group" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][10]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q9_answer_group.$error}">
          <label class="col-2 col-form-label">Q9.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][49]"/></div>

            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="1" v-model="input.q9_answer">
                <trans-text i18nKey="ui[94][50]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="2" v-model="input.q9_answer">
                <trans-text i18nKey="ui[94][51]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="3" v-model="input.q9_answer">
                <trans-text i18nKey="ui[94][52]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="4" v-model="input.q9_answer">
                <trans-text i18nKey="ui[94][53]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="5" v-model="input.q9_answer">
                <trans-text i18nKey="ui[94][54]"/>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" value="6" v-model="input.q9_answer">
                <trans-text i18nKey="ui[94][55]"/>
              </label>
            </div>
            <div class="mb-2">
              <form class="form-inline">
                <input type="text" class="form-control" v-model="input.q9_answer_free_text">
              </form>
            </div>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q9_answer_group" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][11]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q10_answer.$error}">
          <label class="col-2 col-form-label">Q10.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][56]"/></div>

            <form class="form-inline">
              <select class="custom-select mb-2" v-model="input.q10_answer" @change="$v.input.q10_answer.$touch()">
                <option value="1"><trans-text i18nKey="ui[94][57]"/></option>
                <option value="2"><trans-text i18nKey="ui[94][58]"/></option>
                <option value="3"><trans-text i18nKey="ui[94][59]"/></option>
                <option value="4"><trans-text i18nKey="ui[94][60]"/></option>
                <option value="5"><trans-text i18nKey="ui[94][61]"/></option>
              </select>
            </form>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q10_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][12]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q11_answer.$error}">
          <label class="col-2 col-form-label">Q11.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][62]"/></div>

            <form class="form-inline">
              <select class="custom-select mb-2" v-model="input.q11_answer" @change="$v.input.q11_answer.$touch()">
                <option value="1"><trans-text i18nKey="ui[94][63]"/></option>
                <option value="2"><trans-text i18nKey="ui[94][64]"/></option>
                <option value="3"><trans-text i18nKey="ui[94][65]"/></option>
                <option value="4"><trans-text i18nKey="ui[94][66]"/></option>
                <option value="5"><trans-text i18nKey="ui[94][67]"/></option>
              </select>
            </form>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q11_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][13]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.q12_answer.$error}">
          <label class="col-2 col-form-label">Q12.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][68]"/></div>

            <form class="form-inline">
              <select class="custom-select mb-2" v-model="input.q12_answer" @change="$v.input.q12_answer.$touch()">
                <option value="1"><trans-text i18nKey="ui[94][69]"/></option>
                <option value="2"><trans-text i18nKey="ui[94][70]"/></option>
                <option value="3"><trans-text i18nKey="ui[94][71]"/></option>
                <option value="4"><trans-text i18nKey="ui[94][72]"/></option>
                <option value="5"><trans-text i18nKey="ui[94][73]"/></option>
              </select>
            </form>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.q12_answer" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_1'][14]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-2 col-form-label">Q13.</label>
          <div class="col-10">
            <div><trans-text i18nKey="ui[94][74]"/></div>

            <div class="form-group">
              <textarea class="form-control" rows="3" v-model="input.q13_answer"></textarea>
            </div>
          </div>
          <!--<div class="col-12 form-hr">-->
            <!--<hr class="">-->
          <!--</div>-->
        </div>



      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm"><trans-text i18nKey="ui[94][75]" :adjustLangFontSizes="{}"/></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    data () {
      return {
        input: {
          sex_code:null,
          generation_code:null,
          q1_answer:null,
          q2_answer:null,
          q3_answer:null,
          q3_answer_free_text:null,
          q4_answer:null,
          q5_answer:null,
          q6_answer:null,
          q6_answer_free_text:null,
          q7_answer:[],
          q8_answer:[],
          q8_answer_free_text:null,
          q9_answer:[],
          q9_answer_free_text:null,
          q10_answer:null,
          q11_answer:null,
          q12_answer:null,
          q13_answer:null,
        }
      }
    },
    validations: {
      input: {
        sex_code: {
          required
        },
        generation_code: {
          required
        },
        q1_answer: {
          required
        },
        q2_answer: {
          required
        },
        q3_answer_group:["input.q3_answer","input.q3_answer_free_text"],
        q3_answer: {
          required,
        },
        q3_answer_free_text: {
          optionally_required (value) {
            return (this.input.q3_answer === "3")? required(value) : true
          },
        },
        q4_answer: {
          required
        },
        q5_answer: {
          required
        },
        q6_answer_group:["input.q6_answer","input.q6_answer_free_text"],
        q6_answer: {
          required
        },
        q6_answer_free_text:{
          optionally_required (value) {
            return (app.make("_").includes(this.input.q6_answer,"5"))? required(value) : true
          },
        },
        q7_answer: {
        },
        q8_answer_group:["input.q8_answer_free_text"],
        q8_answer_free_text:{
          optionally_required (value) {
            return (app.make("_").includes(this.input.q8_answer,"8"))? required(value) : true
          },
        },
        q9_answer_group:["input.q9_answer_free_text"],
        q9_answer_free_text:{
          optionally_required (value) {
            return (app.make("_").includes(this.input.q9_answer,"6"))? required(value) : true
          },
        },
        q10_answer: {
          required
        },
        q11_answer: {
          required
        },
        q12_answer: {
          required
        },
        q13_answer: {
        },
      }
    },
    created(){
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        let input = Object.assign(this.input)
        input.q7_answer = input.q7_answer.join(",")
        input.q8_answer = input.q8_answer.join(",")
        input.q9_answer = input.q9_answer.join(",")

        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-group{
    font-size: .9rem;
  }

</style>



// WEBPACK FOOTER //
// PageForm.vue?608cdb48